import React, { useEffect, useState } from 'react'
import { url } from '../../../constants/url.js'
import { WebReportSkeleton } from './Web/BlueFormat/WebReportSkeleton';
import { useAuth } from '../../../Context/UserContext';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../pages-css/ReportDownload.css'
import { toast } from 'react-toastify';
import { ApiReportSkeleton } from './API/Blue Format/APIReportSkeleton';
import { WebCERTInReportSkeleton } from './Web/CertIn/WebCERTInReportSkeleton';

import { WebCERTInAuditReportSkeleton } from './Web/AuditReport/WebCERTInAuditReportSkeleton'

import { MobileReportSkeleton } from './Mobile/BlueFormat/MobileReportSkeleton.js'
import { MobileCertInReportSkeleton } from './Mobile/Cert-In/MobileCertInReportSkeleton.js'
import { MobileAuditReportSkeleton } from './Mobile/AuditReport/MobileAuditReportSkeleton.js'
import { SourceCodeSkeleton } from './SourceCode/BlueFormat/SourcecodeBlueformatSkeleton.js';
import { SourceCodeCertInAuditReportSkeleton } from './SourceCode/CertIn/SourceCodeCertInAuditReport.js';
import { SourceCodeAuditReportSkeleton } from './SourceCode/AuditReport/SourceCodeAuditReport.js';

function GenerateReportFiles(props) {

    const [appDiscription, setAppDiscription] = useState([]) /* this is for appDiscription */
    const { projectId } = props

    const { emailVer, logout } = useAuth()
    const [loading, setLoading] = useState(false)

    const [generatedReportData, setGeneratedReportData] = useState([])
    const [projectDetails, setProjectDetails] = useState(null);
    const [pocDetails, setPOCDetails] = useState([])
    const [openInputs, setOpenInputs] = useState(false)

    const [date, setDate] = useState('')
    const [customerName, setCustomerName] = useState()
    const [image, setImage] = useState(null)
    const [author, setAuthor] = useState('')
    const [clientName, setClientName] = useState([])
    const [consultantName, setConsultantName] = useState([])
    const [applicationName, setApplicationName] = useState('')
    const [applicationURL, setApplicationURL] = useState('')
    const [testStartDate, setTestStartDate] = useState('')
    const [testEndDate, setTestEndDate] = useState('')
    const [environmentType, setEnvironmentType] = useState('')
    const [testingType, setTestingType] = useState('')
    const [textAreaValue, setTextAreaValue] = useState([])
    const [userRoles, setUserRoles] = useState(textAreaValue.length > 0 ? textAreaValue : [""]);


    const [imageUrl, setImageUrl] = useState(null);

    const [brokenAccess, setBrokenAccess] = useState('')
    const [cryptoFailures, setCryptoFailures] = useState('')
    const [injection, setInjection] = useState('')
    const [inseureDesign, setInsecureDesign] = useState('')
    const [security, setSecurity] = useState('')
    const [outdatedComp, setOutdatedComp] = useState('')
    const [identification, setIdentification] = useState('')
    const [softwareFailures, setSoftwareFailures] = useState('')
    const [securityFailures, setSecurityFailures] = useState('')
    const [ssrf, setSSRF] = useState('')
    const [vulCount, setVulCount] = useState(0)
    const [critical, setCritical] = useState(0)
    const [high, setHigh] = useState(0)
    const [medium, setMedium] = useState(0)
    const [low, setLow] = useState(0)
    const [info, setInfo] = useState(0)
    const [strongPoint, setStrongPoint] = useState([])
    const [weakPoint, setWeakPoint] = useState([])

    const [mobileOWASP, setMobileOWASP] = useState({
        improperCredential: "",
        inadequateSupply: "",
        insecureAuthentication: "",
        insufficientIO: "",
        insecureComm: "",
        inadequatePrivacy: "",
        insufficientBinary: "",
        securityMisConf: "",
        insecureData: "",
        insufficientCrypto: ""
    })

    const [isImageSelected, setIsImageSelected] = useState(false);
    const [isImageFetched, setIsImageFetched] = useState(false);

    const [strongPoints, setStrongPoints] = useState(strongPoint.length > 0 ? strongPoint : [""])
    const [weakPoints, setWeakPoints] = useState(weakPoint.length > 0 ? weakPoint : [""])

    function capitalizeFirstLetter(string) {
        if (typeof string !== 'string') {
            return string;
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const addStrongPoints = () => {
        setStrongPoints([...strongPoints, ""])
    }

    const removeStrongPoints = (index) => {
        const newConsultantNames = [...strongPoints]
        newConsultantNames.splice(index, 1)
        setStrongPoints(newConsultantNames)
        setStrongPoint(newConsultantNames)
    }

    const handleStrongPoints = (index, value) => {
        const newConsultantNames = [...strongPoints]
        newConsultantNames[index] = capitalizeFirstLetter(value)
        setStrongPoints(newConsultantNames)
        setStrongPoint(newConsultantNames)
    }

    const addWeakPoints = () => {
        setWeakPoints([...weakPoints, ""])
    }

    const removeWeakPoints = (index) => {
        const newConsultantNames = [...weakPoints]
        newConsultantNames.splice(index, 1)
        setWeakPoints(newConsultantNames)
        setWeakPoint(newConsultantNames)
    }

    const handleWeakPoints = (index, value) => {
        const newConsultantNames = [...weakPoints]
        newConsultantNames[index] = capitalizeFirstLetter(value)
        setWeakPoints(newConsultantNames)
        setWeakPoint(newConsultantNames)
    }


    const handleOpenInputs = () => {
        setOpenInputs(true)
    }

    const handleClientImageChange = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

        if (file && allowedTypes.includes(file.type)) {
            setImage(file);
            const url = URL.createObjectURL(file);
            console.log("Image URL: ", url);
            setImageUrl(url);
            setIsImageSelected(true);

        } else {
            setImage(null);
            setImageUrl('');
            setIsImageSelected(false);
        }
    };

    const addUserRoles = () => {
        setUserRoles([...userRoles, ""]);
    };

    const removeUserRoles = (index) => {
        const newUserRoles = [...userRoles];
        newUserRoles.splice(index, 1);
        setUserRoles(newUserRoles);
        setTextAreaValue(newUserRoles);
    };


    const handleUserRoles = (index, value) => {
        const newUserRoles = [...userRoles];
        newUserRoles[index] = capitalizeFirstLetter(value);
        setUserRoles(newUserRoles);
        setTextAreaValue(newUserRoles);
    };

    const updateProjectStates = (project) => {
        setDate(new Date().toLocaleDateString());
        setCustomerName(project?.clientName || "");
        setAuthor(project?.teamLead || "");
        setClientName(project?.clientManagerName || []);
        setConsultantName(project?.teamLead || []);
        setApplicationName(project?.projectName || "");
        setApplicationURL(project?.scope || "");
        setTestStartDate(project?.testStartDate || "");
        setTestEndDate(project?.testEndDate || "");
        setEnvironmentType(project?.environmentType || "");

    };

    const handleGenerateReports = async () => {
        try {
            const response = await fetch(`${url}/getreportdata`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ projectId })
            });

            const reportData = await response.json();

            setGeneratedReportData(reportData.vulnerabilities);
            setProjectDetails(reportData.project);
            updateProjectStates(reportData.project);

            if (reportData?.vulnerabilities) {
                updateSeverityCounts(reportData.vulnerabilities);
                updateWebOWASPStatus(reportData.vulnerabilities);
                updateMobileOWASPStatus(reportData.vulnerabilities)
                const vulnIds = reportData.vulnerabilities.map(vul => vul._id);
                fetchReportDownloadPOC(vulnIds);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchReportDownloadPOC = async (ids) => {
        try {
            const response = await fetch(`${url}/reportdownloadpoc`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ ids }),
            })

            const fileData = await response.json()

            setPOCDetails(fileData)

        } catch (error) {
            console.log(error)
        }
    }

    const updateSeverityCounts = (vulnerabilities) => {
        let critical = 0, high = 0, medium = 0, low = 0, info = 0;

        vulnerabilities.forEach((vul) => {
            switch (vul.severity) {
                case "Critical": critical++; break;
                case "High": high++; break;
                case "Medium": medium++; break;
                case "Low": low++; break;
                case "Info": info++; break;
                default: break;
            }
        });

        setCritical(critical);
        setHigh(high);
        setMedium(medium);
        setLow(low);
        setInfo(info);
        setVulCount(critical + high + medium + low + info);
    };

    const updateWebOWASPStatus = (vulnerabilities) => {
        let brokenAccess = 0, cryptoFailures = 0, injection = 0, inseureDesign = 0,
            security = 0, outdatedComp = 0, identification = 0, softwareFailures = 0,
            securityFailures = 0, ssrf = 0;

        vulnerabilities.forEach((vul) => {
            switch (vul.OWASP) {
                case "Broken Access Control - [A1]": brokenAccess++; break;
                case "Security Misconfiguration - [A2]": cryptoFailures++; break;
                case "Software Supply Chain Failures - [A3]": injection++; break;
                case "Cryptographic Failures - [A4]": inseureDesign++; break;
                case "Injection - [A5]": security++; break;
                case "Insecure Design - [A6]": outdatedComp++; break;
                case "Authentication Failures - [A7]": identification++; break;
                case "Software or Data Integrity Failures - [A8]": softwareFailures++; break;
                case "Security Logging and Alerting Failures - [A9]": securityFailures++; break;
                case "Mishandling of Exceptional Conditions - [A10]": ssrf++; break;
                default: break;
            }
        });

        // set 0 = Protected, 1 = Unprotected
        setBrokenAccess(brokenAccess);
        setCryptoFailures(cryptoFailures);
        setInjection(injection);
        setInsecureDesign(inseureDesign);
        setSecurity(security);
        setOutdatedComp(outdatedComp);
        setIdentification(identification);
        setSoftwareFailures(softwareFailures);
        setSecurityFailures(securityFailures);
        setSSRF(ssrf);
    };

    const updateMobileOWASPStatus = (vulnerabilities) => {
        const counts = {
            improperCredential: 0, inadequateSupply: 0, insecureAuthentication: 0,
            insufficientIO: 0, insecureComm: 0, inadequatePrivacy: 0, insufficientBinary: 0,
            securityMisConf: 0, insecureData: 0, insufficientCrypto: 0
        }

        vulnerabilities.forEach((vul) => {
            switch (vul.OWASP) {
                case "Improper Credential Usage": counts.improperCredential++; break;
                case "Inadequate Supply Chain Security": counts.inadequateSupply++; break;
                case "Insecure Authentication/Authorization": counts.insecureAuthentication++; break;
                case "Insufficient Input/Output Validation": counts.insufficientIO++; break;
                case "Insecure Communication": counts.insecureComm++; break;
                case "Inadequate Privacy Controls": counts.inadequatePrivacy++; break;
                case "Insufficient Binary Protections": counts.insufficientBinary++; break;
                case "Security Misconfiguration": counts.securityMisConf++; break;
                case "Insecure Data Storage": counts.insecureData++; break;
                case "Insufficient Cryptography": counts.insufficientCrypto++; break;
                default: break;
            }
        });
        setMobileOWASP(counts);
    }

    const handleDownloadReportAll = async () => {
        try {
            const {
                applicationType,
                projectType
            } = projectDetails;

            const reportProps = {
                emailVer, logout, date, customerName, author, clientName, consultantName,
                applicationName, applicationURL, testStartDate, testEndDate,
                environmentType, critical, high, medium, low, info, vulCount,
                brokenAccess, cryptoFailures, injection, inseureDesign, security, outdatedComp,
                identification, softwareFailures, securityFailures, ssrf, generatedReportData,
                pocDetails, loading, setLoading, textAreaValue, testingType, userRoles,
                weakPoints, strongPoints, image, imageUrl, appDiscription, mobileOWASP
            };

            if (applicationType === 'WEB' && (projectType === 'NON CERT-In')) {
                await WebReportSkeleton(reportProps);
            } else if (applicationType === 'WEB' && projectType === 'CERT-In') {
                await WebCERTInReportSkeleton(reportProps)
                await WebCERTInAuditReportSkeleton(reportProps)
            } else if (applicationType === 'WEB' && projectType === 'Blue CERT-In') {
                await WebReportSkeleton(reportProps);
                await WebCERTInAuditReportSkeleton(reportProps)
            } else if ((applicationType === 'ANDROID' || applicationType === 'IOS' || applicationType === 'ANDROID & IOS') && projectType === 'NON CERT-In') {
                await MobileReportSkeleton(reportProps)
            }
            else if ((applicationType === 'ANDROID' || applicationType === 'IOS' || applicationType === 'ANDROID & IOS') && projectType === 'CERT-In') {
                await MobileCertInReportSkeleton(reportProps)
                await MobileAuditReportSkeleton(reportProps)
            } else if ((applicationType === 'ANDROID' || applicationType === 'IOS' || applicationType === 'ANDROID & IOS') && projectType === 'Blue CERT-In') {
                await MobileReportSkeleton(reportProps)
                await MobileAuditReportSkeleton(reportProps)
            } else if (applicationType === "Secure Code Review" && projectType === "NON CERT-In") {
                await SourceCodeSkeleton(reportProps)
            } else if (applicationType === "Secure Code Review" && projectType === 'CERT-In') {
                await SourceCodeCertInAuditReportSkeleton(reportProps)
                await SourceCodeAuditReportSkeleton(reportProps)
            } else if (applicationType === "Secure Code Review" && projectType === 'Blue CERT-In') {
                await SourceCodeSkeleton(reportProps)
                await SourceCodeAuditReportSkeleton(reportProps)
            }
            else {
                return
            }
        } catch (err) {
            console.error("Error generating report:", err);
            toast.error("Failed to generate the report.", {
                position: "top-right",
                autoClose: 2500,
                pauseOnHover: false,
            });
        }
    };


    const handleCloseDownload = () => {
        setOpenInputs(false)
    }

    useEffect(() => {
        handleGenerateReports()
    }, [])



    return (
        <div>
            <button
                className="wrap_get_report"
                onClick={() => {
                    handleOpenInputs()
                }}>Generate Report</button>

            {openInputs && (
                <div className='wrap_new_report_data'>
                    <div className='wrap_content_new_report'>

                        <div className='wrap_leftside_new_report'>
                            <div className='report_input_new_data'>
                                <label>Strong point</label>
                                {strongPoints.map((name, index) => (
                                    <div className="practice_data_report" key={index}>
                                        <div className="input_box_report">
                                            <input type="text" placeholder='Strong Points'
                                                value={name}
                                                onChange={(e) => {
                                                    handleStrongPoints(index, e.target.value)
                                                }}>
                                            </input>
                                            {index !== strongPoints.length - 0 && (
                                                <button onClick={() => {
                                                    removeStrongPoints(index)
                                                }}><FontAwesomeIcon icon={faTimes} className='icon-btn' /></button>
                                            )}
                                        </div>
                                        <button className='diff_button_report' onClick={addStrongPoints}>
                                            <span style={{ marginRight: "5px" }}>
                                                <FontAwesomeIcon icon={faPlus} className='plus_icon' />
                                            </span>
                                            Add
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <div className='report_input_new_data'>
                                <label>Weak point</label>
                                {weakPoints.map((name, index) => (
                                    <div className="practice_data_report" key={index}>
                                        <div className="input_box_report">
                                            <input type="text" placeholder='Weak Points'
                                                value={name}
                                                onChange={(e) => {
                                                    handleWeakPoints(index, e.target.value);
                                                }}></input>
                                            {index !== weakPoints.length - 0 && (
                                                <button onClick={() => {
                                                    removeWeakPoints(index)
                                                }}><FontAwesomeIcon icon={faTimes} className='icon-btn' /></button>
                                            )}
                                        </div>
                                        <button className='diff_button_report' onClick={addWeakPoints}>
                                            <span style={{ marginRight: "5px" }}>
                                                <FontAwesomeIcon icon={faPlus} className='plus_icon' />
                                            </span>
                                            Add
                                        </button>
                                    </div>
                                ))}
                            </div>
                            {projectDetails.projectType === 'NON CERT-In' ? (
                                ''
                            ) : (
                                <div className='report_input_new_data'>
                                    <label>Application Discription</label>
                                    <textarea style={{ maxHeight: "150px", maxWidth: "100%" }} type="text" onChange={(e) => { setAppDiscription(e.target.value) }} />
                                </div>
                            )}


                            <div>

                            </div>

                        </div>

                        <div className='wrap_rightside_new_report'>
                            <div className='report_input_new_data'>
                                <label>Testing Type</label>
                                <select value={testingType} onChange={(e) => {
                                    setTestingType(e.target.value)

                                }}>
                                    <option>Select</option>
                                    <option>Black box testing methodology (Unauthenticated Testing)</option>
                                    <option>Combination of Gray Box testing methodology (authenticated testing) and Black Box testing methodology (Unauthenticated Testing)</option>
                                </select>
                            </div>

                            <div className='report_input_new_data'>
                                <label>Client Logo</label>

                                {!isImageSelected && !isImageFetched && !imageUrl && (
                                    <input type='file' onChange={handleClientImageChange} />
                                )}
                                {imageUrl && (
                                    <div>
                                        <img src={imageUrl} alt="Uploaded logo" style={{ width: '100px', height: '30px' }} />
                                    </div>
                                )}
                            </div>

                            {testingType !== "Black box testing methodology (Unauthenticated Testing)" ? (
                                <div className='report_input_new_data'>
                                    <label>
                                        User Roles
                                    </label>
                                    {userRoles.map((name, index) => (
                                        <div className="practice_data_report" key={index}>
                                            <div className="input_box_report">
                                                <input type="text" placeholder='User Roles'
                                                    value={name}
                                                    onChange={(e) => {
                                                        handleUserRoles(index, e.target.value);

                                                    }}></input>
                                                {index !== userRoles.length - 0 && (
                                                    <button onClick={() => {
                                                        removeUserRoles(index)

                                                    }}>
                                                        <FontAwesomeIcon icon={faTimes} className='icon-btn' />
                                                    </button>
                                                )}
                                            </div>
                                            <button className='diff_button_report' onClick={addUserRoles}>
                                                <span style={{ marginRight: "5px" }}>
                                                    <FontAwesomeIcon icon={faPlus} className="plus_icon" />
                                                </span>
                                                Add
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                ''
                            )}
                            <div className='wrap_new_report_buttons'>
                                <button style={{ border: "1px solid #e76a34", }} onClick={() => handleCloseDownload()}>Cancel</button>
                                <button
                                    style={{ backgroundColor: "#e76a34", color:'white' }}
                                    onClick={() => handleDownloadReportAll()}
                                    disabled={loading}
                                >
                                    {loading ? "Downloading..." : "Download"}
                                </button>
                            </div>



                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}

export default GenerateReportFiles
